import { NeedsList } from '../types/needs';

export const mockNeedsLists: NeedsList[] = [
  // Current needs (should show by default)
  {
    id: 'needs-001',
    name: 'Easter Service Setup',
    coordinator: 'Sarah Johnson',
    coordinatorId: '2',
    group: 'Worship Team',
    nextItemNeeded: 'Audio Equipment',
    nextItemNeededDate: '2025-11-15T09:00:00Z',
    itemsOutstandingQty: 5,
    status: 'Outstanding Needs',
    createdDate: '2025-10-20T10:00:00Z',
    isPastNeed: false,
  },
  {
    id: 'needs-002',
    name: 'Youth Camp 2025',
    coordinator: 'Mark Thompson',
    group: 'Youth Ministry',
    nextItemNeeded: 'Camping Tents',
    nextItemNeededDate: '2025-12-01T08:00:00Z',
    itemsOutstandingQty: 12,
    status: 'Outstanding Needs',
    createdDate: '2025-10-22T14:30:00Z',
    isPastNeed: false,
  },
  {
    id: 'needs-003',
    name: 'Community Thanksgiving Dinner',
    coordinator: 'Linda Martinez',
    group: 'Outreach Team',
    nextItemNeeded: 'Turkey',
    nextItemNeededDate: '2025-11-20T10:00:00Z',
    itemsOutstandingQty: 8,
    status: 'Outstanding Needs',
    createdDate: '2025-10-25T09:15:00Z',
    isPastNeed: false,
  },
  {
    id: 'needs-004',
    name: 'Christmas Concert',
    coordinator: 'David Chen',
    group: 'Choir',
    nextItemNeeded: 'Music Stands',
    nextItemNeededDate: '2025-12-10T18:00:00Z',
    itemsOutstandingQty: 3,
    status: 'Outstanding Needs',
    createdDate: '2025-10-28T11:00:00Z',
    isPastNeed: false,
  },
  {
    id: 'needs-005',
    name: 'Women\'s Retreat',
    coordinator: 'Jennifer Wilson',
    group: 'Women\'s Ministry',
    nextItemNeeded: 'Devotional Books',
    nextItemNeededDate: '2025-11-25T08:00:00Z',
    itemsOutstandingQty: 0,
    status: 'All Needs Fulfilled',
    createdDate: '2025-10-15T13:45:00Z',
    isPastNeed: false,
  },
  {
    id: 'needs-006',
    name: 'Senior Lunch Program',
    coordinator: 'Robert Davis',
    coordinatorId: '7',
    group: 'Seniors Ministry',
    nextItemNeeded: 'Folding Tables',
    nextItemNeededDate: '2025-11-12T11:30:00Z',
    itemsOutstandingQty: 6,
    status: 'Outstanding Needs',
    createdDate: '2025-10-18T10:20:00Z',
    isPastNeed: false,
  },
  {
    id: 'needs-007',
    name: 'Baptism Service',
    coordinator: 'Pastor Michael Brown',
    group: 'Leadership Team',
    nextItemNeeded: 'Baptism Robes',
    nextItemNeededDate: '2025-11-08T16:00:00Z',
    itemsOutstandingQty: 2,
    status: 'Outstanding Needs',
    createdDate: '2025-10-26T15:10:00Z',
    isPastNeed: false,
  },
  {
    id: 'needs-008',
    name: 'Kids Sunday School Materials',
    coordinator: 'Amanda Garcia',
    coordinatorId: '10',
    group: 'Children\'s Ministry',
    nextItemNeeded: 'Craft Supplies',
    nextItemNeededDate: '2025-11-05T09:00:00Z',
    itemsOutstandingQty: 0,
    status: 'All Needs Fulfilled',
    createdDate: '2025-10-12T08:30:00Z',
    isPastNeed: false,
  },
  
  // Youth Group (Group 1) needs
  {
    id: 'needs-014',
    name: 'Youth Game Night',
    coordinator: 'John Smith',
    coordinatorId: '1',
    group: 'Youth Group',
    nextItemNeeded: 'Snacks & Drinks',
    nextItemNeededDate: '2025-11-18T19:00:00Z',
    itemsOutstandingQty: 4,
    status: 'Outstanding Needs',
    createdDate: '2025-11-01T14:00:00Z',
    isPastNeed: false,
  },
  {
    id: 'needs-015',
    name: 'Youth Retreat 2025',
    coordinator: 'Sarah Connor',
    group: 'Youth Group',
    nextItemNeeded: 'Transportation',
    nextItemNeededDate: '2025-12-15T08:00:00Z',
    itemsOutstandingQty: 7,
    status: 'Outstanding Needs',
    createdDate: '2025-10-30T10:30:00Z',
    isPastNeed: false,
  },
  {
    id: 'needs-016',
    name: 'Youth Sunday Service',
    coordinator: 'Mike Johnson',
    group: 'Youth Group',
    nextItemNeeded: 'AV Equipment',
    nextItemNeededDate: '2025-11-24T10:00:00Z',
    itemsOutstandingQty: 0,
    status: 'All Needs Fulfilled',
    createdDate: '2025-10-28T09:00:00Z',
    isPastNeed: false,
  },

  // Prayer Group (Group 2) needs
  {
    id: 'needs-017',
    name: 'Prayer Breakfast',
    coordinator: 'Sarah Johnson',
    coordinatorId: '2',
    group: 'Prayer Group',
    nextItemNeeded: 'Breakfast Items',
    nextItemNeededDate: '2025-11-16T07:00:00Z',
    itemsOutstandingQty: 3,
    status: 'Outstanding Needs',
    createdDate: '2025-11-02T16:00:00Z',
    isPastNeed: false,
  },
  {
    id: 'needs-018',
    name: 'Prayer Room Supplies',
    coordinator: 'David Lee',
    group: 'Prayer Group',
    nextItemNeeded: 'Prayer Journals',
    nextItemNeededDate: '2025-11-22T18:00:00Z',
    itemsOutstandingQty: 5,
    status: 'Outstanding Needs',
    createdDate: '2025-10-25T11:30:00Z',
    isPastNeed: false,
  },
  {
    id: 'needs-019',
    name: 'Prayer Walk Event',
    coordinator: 'James Wilson',
    group: 'Prayer Group',
    nextItemNeeded: 'Water Bottles',
    nextItemNeededDate: '2025-11-30T09:00:00Z',
    itemsOutstandingQty: 0,
    status: 'All Needs Fulfilled',
    createdDate: '2025-10-20T13:00:00Z',
    isPastNeed: false,
  },

  // Small Group Alpha (Group 3) needs
  {
    id: 'needs-020',
    name: 'Small Group Study Books',
    coordinator: 'Michael Chen',
    group: 'Small Group Alpha',
    nextItemNeeded: 'Study Guides',
    nextItemNeededDate: '2025-11-14T19:00:00Z',
    itemsOutstandingQty: 6,
    status: 'Outstanding Needs',
    createdDate: '2025-10-28T15:45:00Z',
    isPastNeed: false,
  },
  {
    id: 'needs-021',
    name: 'Small Group Potluck',
    coordinator: 'Emily Rodriguez',
    group: 'Small Group Alpha',
    nextItemNeeded: 'Plates & Utensils',
    nextItemNeededDate: '2025-11-21T18:30:00Z',
    itemsOutstandingQty: 2,
    status: 'Outstanding Needs',
    createdDate: '2025-11-03T10:00:00Z',
    isPastNeed: false,
  },
  {
    id: 'needs-022',
    name: 'Small Group Outreach',
    coordinator: 'Michael Chen',
    group: 'Small Group Alpha',
    nextItemNeeded: 'Care Packages',
    nextItemNeededDate: '2025-12-05T17:00:00Z',
    itemsOutstandingQty: 8,
    status: 'Outstanding Needs',
    createdDate: '2025-10-26T14:20:00Z',
    isPastNeed: false,
  },

  // Past needs (should be filtered out by default)
  {
    id: 'needs-009',
    name: 'Fall Festival',
    coordinator: 'James Anderson',
    group: 'Events Team',
    nextItemNeeded: 'Decorations',
    nextItemNeededDate: '2025-10-15T14:00:00Z',
    itemsOutstandingQty: 0,
    status: 'All Needs Fulfilled',
    createdDate: '2025-09-10T10:00:00Z',
    isPastNeed: true,
  },
  {
    id: 'needs-010',
    name: 'Back to School Drive',
    coordinator: 'Patricia White',
    group: 'Community Outreach',
    nextItemNeeded: 'Backpacks',
    nextItemNeededDate: '2025-08-20T09:00:00Z',
    itemsOutstandingQty: 0,
    status: 'All Needs Fulfilled',
    createdDate: '2025-07-15T11:00:00Z',
    isPastNeed: true,
  },
  {
    id: 'needs-011',
    name: 'Summer VBS',
    coordinator: 'Elizabeth Taylor',
    group: 'Children\'s Ministry',
    nextItemNeeded: 'T-Shirts',
    nextItemNeededDate: '2025-07-10T08:00:00Z',
    itemsOutstandingQty: 0,
    status: 'All Needs Fulfilled',
    createdDate: '2025-06-01T09:30:00Z',
    isPastNeed: true,
  },
  {
    id: 'needs-012',
    name: 'Mission Trip Supplies',
    coordinator: 'Christopher Lee',
    group: 'Missions Team',
    nextItemNeeded: 'Medical Supplies',
    nextItemNeededDate: '2025-09-01T07:00:00Z',
    itemsOutstandingQty: 0,
    status: 'All Needs Fulfilled',
    createdDate: '2025-07-20T14:00:00Z',
    isPastNeed: true,
  },
  {
    id: 'needs-013',
    name: 'Mother\'s Day Brunch',
    coordinator: 'Nancy Moore',
    group: 'Hospitality Team',
    nextItemNeeded: 'Flowers',
    nextItemNeededDate: '2025-05-11T10:00:00Z',
    itemsOutstandingQty: 0,
    status: 'All Needs Fulfilled',
    createdDate: '2025-04-15T12:00:00Z',
    isPastNeed: true,
  },
];
